import { yup } from '@framework/validation/initYup.ts';

export interface IMarginDirective {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

const forceNumber = yup.number().transform(v => v ?? 0);

export const MarginDirectiveSchema: yup.ObjectSchema<IMarginDirective> =
  yup.object({
    top: forceNumber.min(0).default(0).label('Margine superiore'),
    right: forceNumber.min(0).default(0).label('Margine destro'),
    bottom: forceNumber.min(0).default(0).label('Margine inferiore'),
    left: forceNumber.min(0).default(0).label('Margine sinistro'),
  });
